module.exports = __webpack_public_path__ + "static/media/icon-raspberrypi.23d13ed8.svg";